import { createVNode as _createVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container-custom-modal" }
const _hoisted_2 = { class: "card-custom-modal" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "title-custom-modal" }, "CPF na nota", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "subtitle-custom-modal" }, "Adicione seu CPF", -1)
const _hoisted_5 = { class: "card__content-custom-modal" }
const _hoisted_6 = { class: "buttons-container-custom-modal" }
const _hoisted_7 = { class: "bottom-button-custom-modal" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Cancelar")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Confirmar")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_content = _resolveComponent("ion-content")
  const _directive_mask = _resolveDirective("mask")

  return (_openBlock(), _createBlock(_component_ion_content, { class: "custom-modal-transparent" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_ion_input, {
              modelValue: _ctx.dataInvoice,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dataInvoice = $event)),
              placeholder: "000.000.000-00",
              type: "tel",
              class: "content__input-custom-modal",
              autocomplete: "off"
            }, null, 8, ["modelValue"]),
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataInvoice = $event)),
              style: {"display":"none"}
            }, null, 512), [
              [_vModelText, _ctx.dataInvoice],
              [_directive_mask, '###.###.###-##']
            ])
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_ion_button, {
                color: "dark",
                fill: "clear",
                onClick: _ctx.closeModal
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_ion_button, {
                color: "primary",
                onClick: _ctx.confirmData
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}